import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function initials(name: string | null | undefined): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}

export function pluralHe(n: number, one: string, many: string) {
  return n === 1 ? one : `${n.toLocaleString('he-IL')} ${many}`;
}

/** decodeURI that never throws (stored URLs come from untrusted website submissions). */
export function safeDecodeUri(value: string | null | undefined): string {
  if (!value) return '';
  try {
    return decodeURI(value);
  } catch {
    return value;
  }
}
